export const monthOptions = [
  { label: "Enero", value: "Enero" },
  { label: "Febrero", value: "Febrero" },
  { label: "Marzo", value: "Marzo" },
  { label: "Abril", value: "Abril" },
  { label: "Mayo", value: "Mayo" },
  { label: "Junio", value: "Junio" },
  { label: "Julio", value: "Julio" },
  { label: "Agosto", value: "Agosto" },
  { label: "Septiembre", value: "Septiembre" },
  { label: "Octubre", value: "Octubre" },
  { label: "Noviembre", value: "Noviembre" },
  { label: "Diciembre", value: "Diciembre" },
];

export const datosGeneralesFields = [
  {
    key: "organismoInterviniente",
    label: "Organismo Interviniente",
    placeholder: "Ingrese organismo interviniente",
    required: true,
    maxLength: 150,
    sanitizeKey: "basicText",
    patternKey: "basicText",
    formatMessage: "Permite letras, números, espacios y caracteres especiales básicos",
  },
  {
    key: "dependenciaPolicial",
    label: "Dependencia Policial",
    placeholder: "Ingrese dependencia policial",
    required: true,
    maxLength: 100,
    sanitizeKey: "alnumSpace",
    patternKey: "alnumSpace",
    formatMessage: "Solo permite letras, números y espacios",
  },
  {
    key: "lugar",
    label: "Lugar",
    placeholder: "Ingrese lugar",
    required: true,
    maxLength: 100,
    sanitizeKey: "basicText",
    patternKey: "basicText",
    formatMessage: "Permite letras, números, espacios y caracteres especiales básicos",
  },
  {
    key: "fecha",
    label: "Fecha",
    placeholder: "Seleccione fecha",
    type: "date",
    required: true,
  },
  {
    key: "departamento",
    label: "Departamento",
    placeholder: "Ingrese departamento",
    required: true,
    maxLength: 60,
    sanitizeKey: "lettersSpace",
    patternKey: "lettersSpace",
    formatMessage: "Solo permite letras y espacios",
  },
  {
    key: "provincia",
    label: "Provincia",
    placeholder: "Ingrese provincia",
    required: true,
    maxLength: 60,
    sanitizeKey: "lettersSpace",
    patternKey: "lettersSpace",
    formatMessage: "Solo permite letras y espacios",
  },
  {
    key: "hora",
    label: "Hora",
    placeholder: "Seleccione hora",
    type: "time",
    required: true,
  },
  {
    key: "dia",
    label: "Día",
    placeholder: "Ingrese día",
    required: true,
    maxLength: 2,
    sanitizeKey: "day",
    type: "day",
    inputMode: "numeric",
  },
  {
    key: "mes",
    label: "Mes",
    placeholder: "Seleccione mes",
    type: "monthSelect",
    required: true,
  },
  {
    key: "anio",
    label: "Año",
    placeholder: "Ingrese año",
    required: true,
    maxLength: 4,
    sanitizeKey: "year",
    type: "year",
    inputMode: "numeric",
  },
  {
    key: "funcionarioPolicialSuscribe",
    label: "Funcionario Policial que suscribe",
    placeholder: "Ingrese funcionario policial",
    required: true,
    maxLength: 120,
    sanitizeKey: "lettersSpaceName",
    patternKey: "lettersSpaceName",
    formatMessage: "Solo permite letras, espacios, apóstrofes y guiones",
  },
  {
    key: "usuarioSifcop",
    label: "Usuario SIFCOP (SI / NO)",
    placeholder: "Seleccione opción",
    type: "dropdown",
    required: true,
  },
  {
    key: "numeroRequerimientoJudicial",
    label: "N° de requerimiento judicial",
    placeholder: "Ingrese número de requerimiento judicial",
    required: false,
    maxLength: 30,
    sanitizeKey: "alnumSlashHyphen",
    patternKey: "alnumSlashHyphen",
    formatMessage: "Solo permite letras, números, guiones y slash",
  },
];

export const personaFields = [
  {
    key: "nombreApellido",
    label: "Nombre y Apellido",
    placeholder: "Ingrese nombre y apellido",
    required: false,
    maxLength: 120,
    sanitizeKey: "lettersSpace",
    patternKey: "lettersSpace",
    formatMessage: "Solo permite letras y espacios",
  },
  {
    key: "documento",
    label: "DNI / Pasaporte / Documento N°",
    placeholder: "Ingrese documento",
    required: false,
    maxLength: 20,
    sanitizeKey: "alnumHyphen",
    patternKey: "alnumHyphen",
    formatMessage: "Solo permite letras, números y guiones",
  },
  {
    key: "fechaNacimiento",
    label: "Fecha de nacimiento",
    placeholder: "dd/mm/yyyy",
    type: "birthDate",
    required: false,
  },
  {
    key: "nacionalidad",
    label: "Nacionalidad",
    placeholder: "Ingrese nacionalidad",
    required: false,
    maxLength: 60,
    sanitizeKey: "lettersSpace",
    patternKey: "lettersSpace",
    formatMessage: "Solo permite letras y espacios",
  },
  {
    key: "domicilio",
    label: "Domicilio",
    placeholder: "Ingrese domicilio",
    required: false,
    maxLength: 200,
    sanitizeKey: "basicText",
    patternKey: "basicText",
    formatMessage: "Permite letras, números, espacios y caracteres especiales básicos",
  },
];

export const dynamicSections = [
  {
    key: "vehiculos",
    title: "Sección A - Vehículo",
    itemLabel: "Vehículo",
    addLabel: "Agregar vehículo",
    fields: [
      {
        key: "dominio",
        label: "Dominio",
        placeholder: "Ingrese dominio",
        required: false,
        maxLength: 10,
        sanitizeKey: "alnum",
        patternKey: "alnum",
        formatMessage: "Solo permite valores alfanuméricos",
        uppercase: true,
      },
      {
        key: "anio",
        label: "Año",
        placeholder: "Ingrese año",
        required: false,
        maxLength: 4,
        sanitizeKey: "year",
        type: "year",
        inputMode: "numeric",
      },
      {
        key: "tipoVehiculo",
        label: "Tipo Vehículo",
        placeholder: "Ingrese tipo de vehículo",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnumSpace",
        patternKey: "alnumSpace",
        formatMessage: "Solo permite letras, números y espacios",
      },
      {
        key: "marca",
        label: "Marca",
        placeholder: "Ingrese marca",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnumSpace",
        patternKey: "alnumSpace",
        formatMessage: "Solo permite letras, números y espacios",
      },
      {
        key: "numeroMotor",
        label: "Número de motor",
        placeholder: "Ingrese número de motor",
        required: false,
        maxLength: 30,
        sanitizeKey: "alnum",
        patternKey: "alnum",
        formatMessage: "Solo permite letras y números",
      },
      {
        key: "numeroChasis",
        label: "Número de chasis",
        placeholder: "Ingrese número de chasis",
        required: false,
        maxLength: 30,
        sanitizeKey: "alnum",
        patternKey: "alnum",
        formatMessage: "Solo permite letras y números",
      },
      {
        key: "modelo",
        label: "Modelo",
        placeholder: "Ingrese modelo",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnumSpace",
        patternKey: "alnumSpace",
        formatMessage: "Solo permite letras, números y espacios",
      },
      {
        key: "color",
        label: "Color",
        placeholder: "Ingrese color",
        required: false,
        maxLength: 30,
        sanitizeKey: "lettersSpace",
        patternKey: "lettersSpace",
        formatMessage: "Solo permite letras y espacios",
      },
    ],
  },
  {
    key: "armas",
    title: "Sección B - Arma",
    itemLabel: "Arma",
    addLabel: "Agregar arma",
    fields: [
      {
        key: "tipoArma",
        label: "Tipo de arma",
        placeholder: "Ingrese tipo de arma",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnumSpace",
        patternKey: "alnumSpace",
        formatMessage: "Solo permite letras, números y espacios",
      },
      {
        key: "marca",
        label: "Marca",
        placeholder: "Ingrese marca",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnumSpace",
        patternKey: "alnumSpace",
        formatMessage: "Solo permite letras, números y espacios",
      },
      {
        key: "modelo",
        label: "Modelo",
        placeholder: "Ingrese modelo",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnumSpace",
        patternKey: "alnumSpace",
        formatMessage: "Solo permite letras, números y espacios",
      },
      {
        key: "calibre",
        label: "Calibre",
        placeholder: "Ingrese calibre",
        required: false,
        maxLength: 20,
        sanitizeKey: "calibre",
        patternKey: "calibre",
        formatMessage: "Solo permite letras, números, punto y coma",
      },
      {
        key: "numeroSerie",
        label: "Número de serie",
        placeholder: "Ingrese número de serie",
        required: false,
        maxLength: 30,
        sanitizeKey: "alnum",
        patternKey: "alnum",
        formatMessage: "Solo permite letras y números",
      },
    ],
  },
  {
    key: "elementos",
    title: "Sección C - Elemento",
    itemLabel: "Elemento",
    addLabel: "Agregar elemento",
    fields: [
      {
        key: "tipoElemento",
        label: "Tipo de elemento",
        placeholder: "Ingrese tipo de elemento",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnumSpace",
        patternKey: "alnumSpace",
        formatMessage: "Solo permite letras, números y espacios",
      },
      {
        key: "identificacion",
        label: "Identificación",
        placeholder: "Ingrese identificación",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnum",
        patternKey: "alnum",
        formatMessage: "Solo permite valores alfanuméricos",
      },
      {
        key: "modelo",
        label: "Modelo",
        placeholder: "Ingrese modelo",
        required: false,
        maxLength: 50,
        sanitizeKey: "alnumSpace",
        patternKey: "alnumSpace",
        formatMessage: "Solo permite letras, números y espacios",
      },
      {
        key: "descripcion",
        label: "Descripción",
        placeholder: "Ingrese descripción",
        required: false,
        maxLength: 300,
        type: "textarea",
        sanitizeKey: "description",
        patternKey: "description",
        formatMessage: "Texto libre controlado con máximo de 300 caracteres",
      },
    ],
  },
];

const patterns = {
  basicText: /^[A-Za-zÀ-ÿ0-9\s.,:;/'"#°ºª()_-]+$/,
  alnumSpace: /^[A-Za-zÀ-ÿ0-9\s]+$/,
  lettersSpace: /^[A-Za-zÀ-ÿ\s]+$/,
  lettersSpaceName: /^[A-Za-zÀ-ÿ\s'-]+$/,
  alnumHyphen: /^[A-Za-z0-9-]+$/,
  alnumSlashHyphen: /^[A-Za-z0-9/-]+$/,
  alnum: /^[A-Za-z0-9]+$/,
  calibre: /^[A-Za-z0-9.,]+$/,
  description: /^[A-Za-zÀ-ÿ0-9\s.,:;/'"#°ºª()_-]+$/,
};

const sanitizers = {
  basicText: (value) => value.replace(/[^A-Za-zÀ-ÿ0-9\s.,:;/'"#°ºª()_-]/g, ""),
  alnumSpace: (value) => value.replace(/[^A-Za-zÀ-ÿ0-9\s]/g, ""),
  lettersSpace: (value) => value.replace(/[^A-Za-zÀ-ÿ\s]/g, ""),
  lettersSpaceName: (value) => value.replace(/[^A-Za-zÀ-ÿ\s'-]/g, ""),
  alnumHyphen: (value) => value.replace(/[^A-Za-z0-9-]/g, ""),
  alnumSlashHyphen: (value) => value.replace(/[^A-Za-z0-9/-]/g, ""),
  alnum: (value) => value.replace(/[^A-Za-z0-9]/g, ""),
  calibre: (value) => value.replace(/[^A-Za-z0-9.,]/g, ""),
  description: (value) => value.replace(/[^A-Za-zÀ-ÿ0-9\s.,:;/'"#°ºª()_-]/g, ""),
  day: (value) => value.replace(/\D/g, ""),
  year: (value) => value.replace(/\D/g, ""),
};

const buildRuleMap = (fields) =>
  fields.reduce((acc, field) => {
    acc[field.key] = field;
    return acc;
  }, {});

const sectionRuleMaps = {
  datosGeneralesActa: buildRuleMap(datosGeneralesFields),
  personaRegistrada: buildRuleMap(personaFields),
  vehiculos: buildRuleMap(dynamicSections.find((section) => section.key === "vehiculos").fields),
  armas: buildRuleMap(dynamicSections.find((section) => section.key === "armas").fields),
  elementos: buildRuleMap(dynamicSections.find((section) => section.key === "elementos").fields),
};

const isEmpty = (value) =>
  value === null || value === undefined || (typeof value === "string" && value.trim() === "");

const isValidIsoDate = (value) => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;

  const parsed = new Date(`${value}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return false;

  return parsed.toISOString().slice(0, 10) === value;
};

const isValidDateObject = (value) => value instanceof Date && !Number.isNaN(value.getTime());

const isFutureDate = (value) => {
  const today = new Date();
  const todayIso = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    .toISOString()
    .slice(0, 10);

  return value > todayIso;
};

const parseMaskedDate = (value) => {
  if (typeof value !== "string" || !/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return null;

  const [day, month, year] = value.split("/").map(Number);
  const parsed = new Date(year, month - 1, day);

  if (Number.isNaN(parsed.getTime())) return null;
  if (parsed.getFullYear() !== year) return null;
  if (parsed.getMonth() !== month - 1) return null;
  if (parsed.getDate() !== day) return null;

  return parsed;
};

const isFutureMaskedDate = (value) => {
  const parsed = parseMaskedDate(value);
  if (!parsed) return false;

  const today = new Date();
  const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  return parsed > todayDate;
};

export const todayIso = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
  .toISOString()
  .slice(0, 10);

export const getSifcopFieldRule = (sectionName, fieldKey) =>
  sectionRuleMaps[sectionName]?.[fieldKey] || null;

export const sanitizeSifcopValue = (sectionName, fieldKey, rawValue) => {
  const rule = getSifcopFieldRule(sectionName, fieldKey);
  if (!rule) return rawValue ?? "";

  if (["date", "time", "birthDate", "monthSelect", "dropdown"].includes(rule.type)) {
    return rawValue ?? "";
  }

  let value = `${rawValue ?? ""}`;

  if (rule.sanitizeKey && sanitizers[rule.sanitizeKey]) {
    value = sanitizers[rule.sanitizeKey](value);
  }

  if (rule.uppercase) {
    value = value.toUpperCase();
  }

  if (rule.maxLength) {
    value = value.slice(0, rule.maxLength);
  }

  return value;
};

export const validateSifcopValue = (sectionName, fieldKey, rawValue) => {
  const rule = getSifcopFieldRule(sectionName, fieldKey);
  if (!rule) return "";

  const value = typeof rawValue === "string" ? rawValue.trim() : rawValue;

  if (rule.required && isEmpty(value)) {
    return "Campo obligatorio";
  }

  if (!rule.required && isEmpty(value)) {
    return "";
  }

  if (rule.maxLength && `${value}`.length > rule.maxLength) {
    return `Máximo ${rule.maxLength} caracteres`;
  }

  if (rule.type === "date") {
    return isValidDateObject(value) || isValidIsoDate(value) ? "" : "Fecha inválida";
  }

  if (rule.type === "birthDate") {
    if (!parseMaskedDate(value)) return "Fecha inválida";
    return isFutureMaskedDate(value) ? "No se permiten fechas futuras" : "";
  }

  if (rule.type === "time") {
    return /^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/.test(value)
      ? ""
      : "Formato HH:mm inválido";
  }

  if (rule.type === "day") {
    if (!/^\d{1,2}$/.test(value)) return "Solo números";

    const numericDay = Number(value);
    return numericDay >= 1 && numericDay <= 31 ? "" : "Debe estar entre 1 y 31";
  }

  if (rule.type === "year") {
    return /^\d{4}$/.test(value) ? "" : "Debe tener 4 dígitos";
  }

  if (rule.type === "monthSelect") {
    return monthOptions.some((month) => month.value === value) ? "" : "Mes inválido";
  }

  if (rule.type === "dropdown") {
    return ["SI", "NO"].includes(value) ? "" : "Seleccione una opción válida";
  }

  if (rule.patternKey && patterns[rule.patternKey] && !patterns[rule.patternKey].test(value)) {
    return rule.formatMessage || "Formato inválido";
  }

  return "";
};
